module.exports = __webpack_public_path__ + "img/page22.15e86a5c.gif";